import { render } from "./TrendingPopover.vue?vue&type=template&id=73c22666&scoped=true"
import script from "./TrendingPopover.vue?vue&type=script&lang=js"
export * from "./TrendingPopover.vue?vue&type=script&lang=js"

import "./TrendingPopover.vue?vue&type=style&index=0&id=73c22666&scoped=true&lang=scss"
import "./TrendingPopover.vue?vue&type=style&index=1&id=73c22666&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c22666"]])

export default __exports__